import { useEffect, useState } from "react";
import { Alert, Button } from "@mui/material";
import { useAuth } from "./Auth/useAuth";

export default function SessionRecoveryNotice() {
  const { sessionIssue, recoverSession, retrySession } = useAuth();
  const [eventIssue, setEventIssue] = useState(null);
  const [recovering, setRecovering] = useState(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const handleExpired = (event) => setEventIssue(event.detail?.reason || "interaction_required");
    const handleRecovered = () => setEventIssue(null);
    window.addEventListener("fieldprint:session-expired", handleExpired);
    window.addEventListener("fieldprint:session-recovered", handleRecovered);
    return () => {
      window.removeEventListener("fieldprint:session-expired", handleExpired);
      window.removeEventListener("fieldprint:session-recovered", handleRecovered);
    };
  }, []);
  const issue = sessionIssue || eventIssue;
  const needsSignIn = ["interaction_required", "interaction_cancelled"].includes(issue);
  if (!issue) return null;
  const attemptRecovery = async (interactive) => {
    setRecovering(true);
    setFailed(false);
    try {
      const recovered = await (interactive ? recoverSession?.() : retrySession?.());
      if (recovered) setEventIssue(null);
      else setFailed(true);
    } catch {
      setFailed(true);
    } finally {
      setRecovering(false);
    }
  };
  return <Alert severity="warning" action={<div style={{ display: "flex", flexWrap: "wrap" }}>
    <Button color="inherit" disabled={recovering} onClick={() => attemptRecovery(needsSignIn)}>
      {recovering ? "Reconnecting…" : needsSignIn ? "Sign in again" : "Retry connection"}
    </Button>
    {!needsSignIn && <Button color="inherit" disabled={recovering} onClick={() => attemptRecovery(true)}>Sign in again</Button>}
  </div>}>
    {failed ? "Recovery did not finish. Try again. " : needsSignIn ? "Your session needs sign-in. " : issue === "access_denied" ? "Access could not be confirmed. " : "The connection is temporarily unavailable. "}
    Your edits remain on this page. Saving and syncing need a confirmed connection.
  </Alert>;
}
